import { Action } from '@ngrx/store';
import { Expertise } from '../../shared/models/expertise';
import { Prestation } from '../../shared/models/prestation';
export const LOAD_EXPERTISES = '[Expertise] Load expertises...';
export const LOAD_EXPERTISES_SUCCESS = '[Expertise] Load expertises success...';
export const LOAD_EXPERTISES_ERROR = '[Expertise] Load expertises error...';
export const LOAD_EXPERTISE = '[Expertise] Load expertise...';
export const LOAD_EXPERTISE_SUCCESS = '[Expertise] Load expertise success...';
export const LOAD_EXPERTISE_ERROR = '[Expertise] Load expertise error...';
export const OPEN_TAB = '[Expertise] open tab...';
export const CLOSE_TAB = '[Expertise] close tab...';
export const SAVE_EXPERTISE = '[Expertise] Save expertise...';
export const SAVE_EXPERTISE_SUCCESS = '[Expertise] Save expertise success...';
export const SAVE_EXPERTISE_ERROR = '[Expertise] Save expertise error...';
export const ADD_EXPERTISE = '[Expertise] Add expertise...';
export const UPDATE_PRESTATION = '[Expertise] Update prestation...';
export const UPDATE_PRESTATION_SUCCESS = '[Expertise] Update prestation success...';
export const UPDATE_PRESTATION_ERROR = '[Expertise] Update prestation error...';
export const ADD_PRESTATION = '[Expertise] Add prestation...';
export const CANCEL_ADD_PRESTATION = '[Expertise] Cancel add prestation...';
export const EXPERTISE_WORKFLOW = '[Expertise] do action...';
export const EXPERTISE_WORKFLOW_SUCCESS = '[Expertise] do action success...';
export const EXPERTISE_WORKFLOW_ERROR = '[Expertise] do action error...';
export const DELETE_EXPERTISE = '[Expertise] delete expertise...';
export const DELETE_EXPERTISE_SUCCESS = '[Expertise] delete expertise success...';
export const DELETE_EXPERTISE_ERROR = '[Expertise] delete expertise error...';
export const DELETE_PRESTATION = '[Expertise] delete prestation...';
export const DELETE_PRESTATION_SUCCESS = '[Expertise] delete prestation success...';
export const DELETE_PRESTATION_ERROR = '[Expertise] delete prestation error...';
export const EXPERTISE_ACOMPTE = '[Expertise] add acompte...';
export const EXPERTISE_ACOMPTE_SUCCESS = '[Expertise] add acompte success...';
export const EXPERTISE_ACOMPTE_ERROR = '[Expertise] add acompte error...';
export const SET_CONSIGNEMENT = '[Expertise] set consignement...';
export const DELETE_CONSIGNEMENT = '[Expertise] delete consignement...';



export class LoadExpertisesAction implements Action {
    readonly type = LOAD_EXPERTISES;
    constructor(
		public sortField: string,
		public sortOrder: number,
		public filters: any,
		public first: number,
		public rows: number
    ) {
    }
}

export class LoadExpertisesSuccessAction implements Action {
    readonly type = LOAD_EXPERTISES_SUCCESS;
    constructor ( public expertises: any[], public totalCount: number ) {}
}

export class LoadExpertisesErrorAction implements Action {
    readonly type = LOAD_EXPERTISES_ERROR;
    constructor ( public error: any ) {}
}
export class SetConsignmentAction implements Action {
    readonly type = SET_CONSIGNEMENT;
    constructor ( public consignment: any ) {}
}
export class DeleteConsignmentAction implements Action {
    readonly type = DELETE_CONSIGNEMENT;
    constructor ( public expertise_id: any, public id: any ) {}
}

export class LoadExpertiseAction implements Action {
    readonly type = LOAD_EXPERTISE;
    constructor(
        public id: number,
    ) {
    }
}

export class LoadExpertiseSuccessAction implements Action {
    readonly type = LOAD_EXPERTISE_SUCCESS;
    constructor ( public expertise: any) {}
}

export class LoadExpertiseErrorAction implements Action {
    readonly type = LOAD_EXPERTISE_ERROR;
    constructor ( public error: any ) {}
}

export class CloseTabAction implements Action {
    readonly type = CLOSE_TAB;
    constructor ( public id: number ) {}
}

export class OpenTabAction implements Action {
    readonly type = OPEN_TAB;
    constructor ( public id: number ) {}
}


export class SaveExpertiseAction implements Action {
    readonly type = SAVE_EXPERTISE;
    constructor(
        public expertise: Expertise,
    ) {
    }
}

export class SaveExpertiseSuccessAction implements Action {
    readonly type = SAVE_EXPERTISE_SUCCESS;
    constructor (        public id: number, public expertise: any) {}
}

export class SaveExpertiseErrorAction implements Action {
    readonly type = SAVE_EXPERTISE_ERROR;
    constructor ( public id:number,  public error: any ) {}
}

export class AddExpertiseAction implements Action {
    readonly type = ADD_EXPERTISE;
    constructor ( ) {}
}

export class UpdatePrestationAction implements Action {
    readonly type = UPDATE_PRESTATION;
    constructor(
        public expertiseId: number,
        public prestation: Prestation
    ) {
    }
}

export class UpdatePrestationSuccessAction implements Action {
    readonly type = UPDATE_PRESTATION_SUCCESS;
    constructor ( public expertiseId: number, public prestationId: number,  public prestation: Prestation) {}
}

export class UpdatePrestationErrorAction implements Action {
    readonly type = UPDATE_PRESTATION_ERROR;
    constructor ( public expertiseId:number,  public error: any ) {}
}

export class AddPrestationAction implements Action {
    readonly type = ADD_PRESTATION;
    constructor(
        public expertiseId: number,
        public prestation: Prestation,
    ) {
    }
}

export class CancelAddPrestationAction implements Action {
    readonly type = CANCEL_ADD_PRESTATION;
    constructor(
        public expertiseId: number,
        public prestationId: number,
    ) {
    }
}

export class ExpertiseWorkflowAction implements Action {
    readonly type = EXPERTISE_WORKFLOW;
    constructor (public id:number,  public action: any ) {}
}
export class ExpertiseWorkflowSuccessAction implements Action {
    readonly type = SAVE_EXPERTISE_SUCCESS;
    constructor ( public id: number, public expertise: any) {}
}

export class ExpertiseWorkflowErrorAction implements Action {
    readonly type = EXPERTISE_WORKFLOW_ERROR;
    constructor ( public id:number,  public error: any ) {}
}

export class ExpertiseAddAcompteAction implements Action {
    readonly type = EXPERTISE_ACOMPTE;
    constructor (public id:number,  public amount: any ) {}
}
export class ExpertiseAddAcompteSuccessAction implements Action {
    readonly type = SAVE_EXPERTISE_SUCCESS;
    constructor ( public id: number, public expertise: any) {}
}

export class ExpertiseAddAcompteErrorAction implements Action {
    readonly type = EXPERTISE_WORKFLOW_ERROR;
    constructor ( public id:number,  public error: any ) {}
}

export class DeleteExpertiseAction implements Action {
    readonly type = DELETE_EXPERTISE;
    constructor (public id:number ) {}
}
export class DeleteExpertiseSuccessAction implements Action {
    readonly type = DELETE_EXPERTISE_SUCCESS;
    constructor ( public id: number ) {}
}

export class DeleteExpertiseErrorAction implements Action {
    readonly type = DELETE_EXPERTISE_ERROR;
    constructor ( public id:number,  public error: any ) {}
}

export class DeletePrestationAction implements Action {
    readonly type = DELETE_PRESTATION;
    constructor (public expertiseId:number, public id:number ) {}
}
export class DeletePrestationSuccessAction implements Action {
    readonly type = DELETE_PRESTATION_SUCCESS;
    constructor ( public expertiseId:number,public id: number ) {}
}

export class DeletePrestationErrorAction implements Action {
    readonly type = DELETE_PRESTATION_ERROR;
    constructor ( public id:number,  public error: any ) {}
}

export type expertiseActions = LoadExpertisesAction | LoadExpertisesSuccessAction |
LoadExpertisesErrorAction | LoadExpertiseAction | LoadExpertiseSuccessAction |
LoadExpertiseErrorAction | OpenTabAction | CloseTabAction | SaveExpertiseAction | SaveExpertiseSuccessAction |
SaveExpertiseErrorAction | AddExpertiseAction |
UpdatePrestationAction | UpdatePrestationSuccessAction | UpdatePrestationErrorAction |
AddPrestationAction | CancelAddPrestationAction | ExpertiseWorkflowAction | ExpertiseWorkflowErrorAction |
ExpertiseWorkflowSuccessAction | DeleteExpertiseAction | DeleteExpertiseErrorAction |
DeleteExpertiseSuccessAction | DeletePrestationAction | DeletePrestationErrorAction |
DeletePrestationSuccessAction | ExpertiseAddAcompteAction | SetConsignmentAction | DeleteConsignmentAction
;

